package com.shadowings.gero.presentation.component.quiz

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.shadowings.gero.presentation.component.GeroButton
import com.shadowings.gero.presentation.ui.correctBg
import com.shadowings.gero.presentation.ui.correctBorder
import com.shadowings.gero.presentation.ui.disabledNeutralBorder
import com.shadowings.gero.presentation.ui.disabledNeutralText
import com.shadowings.gero.presentation.ui.neutralWhite
import com.shadowings.gero.presentation.ui.wrongBg
import com.shadowings.gero.presentation.ui.wrongBorder
import org.jetbrains.compose.resources.stringResource
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.conferma_btn
import gero.composeapp.generated.resources.continua_btn



@Composable
fun QuizBottomButton(
    pending: Boolean,
    correct: Boolean,
    enabled: Boolean,
    modifier: Modifier,
    onClick: () -> Unit,
) {

    Column(
        Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        val dimmedBg = MaterialTheme.colorScheme.surfaceContainerHighest

        val backgroundColor = if (enabled) {
            if (pending) {
                MaterialTheme.colorScheme.primaryContainer
            } else {
                if (correct) {
                    correctBg
                } else {
                    wrongBg
                }
            }
        } else {
            dimmedBg
        }

        val dimmedBorder = disabledNeutralBorder

        val borderColor = if (enabled) {
            if (pending) {
                MaterialTheme.colorScheme.primary
            } else {
                if (correct) {
                    correctBorder
                } else {
                    wrongBorder
                }
            }
        } else {
            dimmedBorder
        }

        val dimmedText = disabledNeutralText

        val textColor = if (enabled) {
            if (pending) {
                MaterialTheme.colorScheme.onPrimaryContainer
            } else {
                neutralWhite
            }
        } else {
            dimmedText
        }
        GeroButton(
            modifier = modifier,
            enabled = enabled,
            title = if (pending) {
                stringResource(Res.string.conferma_btn)
            } else {
                stringResource(Res.string.continua_btn)
            },
            backgroundColor = backgroundColor,
            borderColor = borderColor,
            textColor = textColor,
            hapticFeedbackOnClick = !pending,
        ) {
            onClick.invoke()
        }
    }
}